import { render, staticRenderFns } from "./ProductSliderSection.vue?vue&type=template&id=38a875a6&scoped=true&"
import script from "./ProductSliderSection.vue?vue&type=script&lang=ts&"
export * from "./ProductSliderSection.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSliderSection.vue?vue&type=style&index=0&id=38a875a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a875a6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductSlider: require('/usr/src/app/components/storyblok/ProductSlider.vue').default})
